// extracted by mini-css-extract-plugin
export var dateLabel = "_4a-0";
export var dateLabelError = "_4a-1";
export var fullWidth = "_4a-2";
export var smaller = "_4a-3";